import * as React from 'react'

import { Variation } from '../../../../articlesContainer'
import './ManageAiVariationsLoadingSpinner.scss'
import { useManageAiVariationsLoadingSpinner } from './useManageAiVariationsLoadingSpinner'

export const ManageAiVariationsLoadingSpinner: React.FunctionComponent<{ existingVariations?: Variation[] }> = (
	props,
) => {
	const { texts } = useManageAiVariationsLoadingSpinner(props.existingVariations || [])

	return (
		<div className="ManageAiVariationsLoadingSpinner">
			{texts.map((text, idx) => (
				<React.Fragment key={text + '@' + idx}>
					{text}
					{idx + 1 < texts.length && <br />}
				</React.Fragment>
			))}
		</div>
	)
}
